import PropTypes from 'prop-types';

import TextFlashcard from './TextFlashcard';
import QuizFlashcard from './QuizFlashcard';
import './FlashcardItem.scss';

const QUIZ_CARD_TYPES = ['mcq', 'true_false'];

/**
 * Routes a flashcard to the correct presentation by cardType:
 * `mcq` / `true_false` -> interactive QuizFlashcard, everything else -> TextFlashcard.
 */
const FlashcardItem = ({ cardType, ...rest }) => {
  if (QUIZ_CARD_TYPES.includes(cardType)) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <QuizFlashcard cardType={cardType} {...rest} />;
  }
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <TextFlashcard {...rest} />;
};

FlashcardItem.propTypes = {
  cardType: PropTypes.string,
};

export default FlashcardItem;
